module.exports = __webpack_public_path__ + "static/media/bytt-no-1.cc3ef9c9.mp3";